import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WindowStackItem } from '../../context/window-stack/WindowStackItem';
import { HideOverflow } from '../hide-overflow/HideOverflow';
import { WindowBody } from '../window/partials/WindowBody';
import { WindowHeader } from '../window/partials/WindowHeader';
import { Window } from '../window/Window';
import { UploadMethodsProps } from './CreateUploadMethod';
import { UploadMethodComponent } from './partials/UploadMethodComponent';
import { UploadMethods } from './UploadMethods';

export const UploadMethodsWindow = (({
    isOpen, close,
    methods, onUpload
}: Props) => {

    const { t } = useTranslation();
    const [activeSource, setActiveSource] = useState<keyof UploadMethodsProps>('Dropzone');

    if (!isOpen) {
        return null;
    }

    const onClose = () => {
        setActiveSource('Dropzone');
        close();
    };

    const onActivateSource = (key: keyof UploadMethodsProps) => {
        const { onOpen } = methods[key]!.props;
        onOpen && onOpen();
        setActiveSource(key);
    };

    return (
        <WindowStackItem>
            <Window close={onClose} size='sm' mobileOrigin='center'>
                <WindowHeader onClose={onClose}>
                    {activeSource === 'Dropzone' && t('image_uploader.title')}
                </WindowHeader>

                <WindowBody>
                    <HideOverflow>
                        {activeSource === 'Dropzone' ? (
                            <UploadMethods
                                onUpload={onUpload}
                                close={onClose}
                                methods={methods}
                                setActiveSource={onActivateSource} />
                        ) : (
                            <UploadMethodComponent
                                close={onClose}
                                onUpload={onUpload}
                                method={methods[activeSource]!} />
                        )}
                    </HideOverflow>
                </WindowBody>
            </Window>
        </WindowStackItem>
    );
});

type Props = {
    isOpen: boolean;
    close: () => void;
    methods: UploadMethodsProps;
    onUpload?: () => void;
};